class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.searchInput = this.querySelector(
      ".custom-search-results #Search-In-Template"
    );
    this.productGrid = document.querySelector(
      ".custom-search-results #product-grid"
    );
    this.originalProductItems = [];
    this.debounceSearchTimer = null;
    this.debounceSearchDelay = 400;

    if (this.searchInput) {
      this.initSearch();
    }

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    facetForm.addEventListener("change", (event) => {
      if (event.target.type === "checkbox") {
        this.onSubmitHandler(event);
      }
    });

    const facetWrapper = document.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  initSearch() {
    if (this.productGrid) {
      setTimeout(() => {
        this.originalProductItems = Array.from(
          this.productGrid.querySelectorAll("li.grid__item")
        );
        const params = new URLSearchParams(window.location.search);
        const searchTerm = params.get("q");
        if (searchTerm && this.searchInput) {
          this.searchInput.value = searchTerm;
          this.performSearch(searchTerm);
        }
      }, 100);
    }

    this.searchInput.addEventListener(
      "input",
      this.handleSearchInput.bind(this)
    );
    const searchButton = this.searchInput
      .closest(".field")
      ?.querySelector(".search__button");
    if (searchButton) {
      searchButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.performSearch(this.searchInput.value);
      });
    }
  }
  displayEmptyResults() {
    const emptyGrid = document.getElementById("empty-results");
    const productGrid = document.getElementById("product-grid");

    if (productGrid) productGrid.style.display = "none";
    if (emptyGrid) emptyGrid.style.display = "block";

    const showMoreBtn = document.querySelector(".show-more-products");
    if (showMoreBtn) showMoreBtn.style.display = "none";
  }

  hideEmptyResults() {
    const emptyGrid = document.getElementById("empty-results");
    const productGrid = document.getElementById("product-grid");

    if (emptyGrid) emptyGrid.style.display = "none";
    if (productGrid) productGrid.style.display = "flex";

    const showMoreBtn = document.querySelector(".show-more-products");
    if (showMoreBtn) showMoreBtn.style.display = "block";
  }

  handleSearchInput(e) {
    clearTimeout(this.debounceSearchTimer);
    this.debounceSearchTimer = setTimeout(() => {
      this.performSearch(e.target.value);
    }, this.debounceSearchDelay);
  }
  async performSearch(query) {
    if (!this.productGrid) {
      this.productGrid = document.getElementById("product-grid");
    }
    const productId = [];
    if (!this.originalProductItems || this.originalProductItems.length === 0) {
      this.originalProductItems = Array.from(
        this.productGrid.querySelectorAll("li.grid__item")
      );
      productId = Array.from(
        this.productGrid.querySelectorAll(".card__heading")
      );
    }

    if (!this.productGrid || !this.originalProductItems.length) return;
    document.querySelectorAll(".search-facet__input").forEach((input) => {
      input.value = query;
    });

    query = query.toLowerCase().trim();
    if (!query) {
      this.hideEmptyResults();
      this.showAllProducts();
      this.updateProductCount();
      this.updateURL("q", "");
      return;
    }

    const productCountDesktop = document.getElementById('ProductCountDesktop');
    const productAllPages = Number(productCountDesktop.dataset?.pages || 0);
    const currentPage = Math.ceil(this.originalProductItems.length / 12)

    let visibleCount = 0;
    try {
      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(
          query
        )}&resources[type]=product&resources[options][unavailable_products]=hide`
      );
      const data = await res.json();

      if (data?.resources?.results?.products.length === 0) {
        this.displayEmptyResults();
        this.updateProductCount(0);
        return;
      } else {
        this.hideEmptyResults();
      }
      // console.log("Have recommendations", data);
      // const fetchedIds = new Set(
      //   data?.resources?.results?.products.map((p) => p.id.toString())
      // );

      this.originalProductItems.forEach((item) => {
        const productCard = item.querySelector(".card");
        const productTitle = productCard.querySelector(".card__title")?.textContent.toLowerCase();
        
        // const productId = productCard?.querySelector(
        //   ".jdgm-widget.jdgm-preview-badge.jdgm-preview-badge--with-link"
        // )?.dataset?.id;

        if (productTitle.includes(query)) {
          item.style.display = "";
          visibleCount++;
        } else {
          item.style.display = "none";
        }
        // if (fetchedIds.has(productId)) {
        //   item.style.display = "";
        //   visibleCount++;
        // } else {
        //   item.style.display = "none";
        // }
      });

      this.updateURL("q", query);
      this.updateProductCount(visibleCount);

      const showMoreBtn = document.querySelector('show-more-pagination');
      
      if (showMoreBtn && currentPage >= productAllPages) {
        showMoreBtn.style.display = "none";
      }

      const searchPageCount = (window.searchPageCount || 1);

      if (visibleCount < 12 * searchPageCount) {
        showMoreBtn.querySelector('button')?.click();
      } else {
        window.searchPageCount = searchPageCount + 1;
      }
    } catch (err) {
      console.error("Error fetching search suggestions:", err);
    }
  }

  showAllProducts() {
    this.originalProductItems.forEach((item) => {
      item.style.display = "";
    });
  }

  updateURL(param, value) {
    const url = new URL(window.location.href);
    if (value) {
      url.searchParams.set(param, value);
    } else {
      url.searchParams.delete(param);
    }
    window.history.replaceState({}, "", url);
  }

  updateProductCount(visibleCount = null) {
    const countElement = document.getElementById("ProductCount");
    const countElementDesktop = document.getElementById("ProductCountDesktop");

    if (!countElement && !countElementDesktop) return;

    const totalCount = Number(countElementDesktop.dataset?.allCount || this.originalProductItems.length);
    const count = visibleCount !== null ? visibleCount : totalCount;
    const countTemplate = countElementDesktop.dataset.template;
    const countText = countTemplate.replace("PRODUCT_COUNT", count).replace("ALL_COUNT", totalCount);

    if (totalCount <= 1) countText.replace('items', 'item')
    if (countElement) countElement.textContent = countText;
    if (countElementDesktop) countElementDesktop.textContent = countText;

    const loadingOverlay = document.querySelector(".loading-overlay");
    if (loadingOverlay) {
      loadingOverlay.classList.add("hidden");
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);

    FacetFiltersForm.toggleGridColumns();

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        FacetFiltersForm.initializeSortDropdown();
        FacetFiltersForm.initializeSortStateFromURL();
      });
    } else {
      FacetFiltersForm.initializeSortDropdown();
      FacetFiltersForm.initializeSortStateFromURL();
    }
  }

  static toggleGridColumns() {
    const productGrid = document.querySelector("#product-grid");
    const filterButton = document.querySelector(
      '[data-action="toggle-filter"]'
    );
    if (filterButton) {
      filterButton.addEventListener("click", (event) => {
        event.preventDefault();

        const filterWrapper = document.querySelector(
          "#FacetsWrapperDesktopContainer"
        );

        if (filterWrapper) {
          filterWrapper.classList.toggle("is-open");
          filterButton.classList.toggle("is-open");

          if (productGrid) {
            const colDesktopClass = Object.values(
              productGrid.classList
            ).find((className) => className.includes("col-desktop"));

            let numCols = null;
            if (colDesktopClass) {
              const match = colDesktopClass.match(/grid--(\d+)-col-desktop/);
              if (match) {
                numCols = parseInt(match[1], 10);
              }
            }
            productGrid.classList.toggle(`grid--${numCols - 1}-col-desktop`);
          }
        }
      });
    }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (window.judgeme) {
      window.judgeme.renderWidgets;
    }

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById(
      "ProductGridContainer"
    ).innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });

    setTimeout(() => {
      document.querySelectorAll("facet-filters-form").forEach((form) => {
        if (form.searchInput && form.productGrid) {
          form.originalProductItems = Array.from(
            form.productGrid.querySelectorAll("li.grid__item")
          );

          const searchValue = form.searchInput.value.trim();
          if (searchValue) {
            form.performSearch(searchValue);
          }
        }
      });
    }, 100);
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const currentSortValue = document.getElementById("SortBy")?.value;
    const currentSortLabel = document.getElementById("SelectedSortOption")
      ?.textContent;

    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const {
            className: previousElementClassName,
            id: previousElementId,
          } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement = document.getElementById(
          closestJSFilterID
        );
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(
          newElementSelector
        );

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    FacetFiltersForm.initializeSortDropdown();

    if (currentSortValue && currentSortLabel) {
      setTimeout(() => {
        FacetFiltersForm.restoreSortState(currentSortValue, currentSortLabel);
      }, 0);
    }

    if (window.initializeFilterSliders) {
      window.initializeFilterSliders();
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    const currentSortValue =
      document.getElementById("SortBy")?.value ||
      FacetFiltersForm.currentSortState.value;
    const currentSortLabel =
      document.getElementById("SelectedSortOption")?.textContent ||
      FacetFiltersForm.currentSortState.label;

    if (currentSortValue && currentSortLabel) {
      FacetFiltersForm.currentSortState = {
        value: currentSortValue,
        label: currentSortLabel,
      };
    }

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(
        selector
      ).innerHTML;
    });

    const filterMobile = document.getElementById("FacetFiltersFormMobile");

    filterMobile && filterMobile.closest("menu-drawer").bindEvents();

    FacetFiltersForm.initializeSortDropdown();

    if (
      FacetFiltersForm.currentSortState.value &&
      FacetFiltersForm.currentSortState.label
    ) {
      setTimeout(() => {
        FacetFiltersForm.restoreSortState(
          FacetFiltersForm.currentSortState.value,
          FacetFiltersForm.currentSortState.label
        );
      }, 0);
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const params = new URLSearchParams();

    const filterCheckboxes = form.querySelectorAll('input[type="checkbox"]');
    const checkboxGroups = {};

    filterCheckboxes.forEach((checkbox) => {
      if (!checkboxGroups[checkbox.name]) {
        checkboxGroups[checkbox.name] = [];
      }
      checkboxGroups[checkbox.name].push(checkbox);
    });

    Object.keys(checkboxGroups).forEach((name) => {
      const checkboxes = checkboxGroups[name];
      checkboxes.forEach((checkbox) => {
        if (
          checkbox.checked &&
          checkbox.value &&
          checkbox.value.trim() !== ""
        ) {
          params.append(checkbox.name, checkbox.value);
        }
      });
    });

    const formData = new FormData(form);
    for (const [key, value] of formData.entries()) {
      const inputElement = form.querySelector(`input[name="${key}"]`);
      if (inputElement && inputElement.type === "checkbox") {
        continue;
      }

      if (value && value.trim() !== "") {
        params.set(key, value);
      }
    }

    const searchInputs = document.querySelectorAll(".search-facet__input");
    if (searchInputs.length > 0) {
      const searchTerm = searchInputs[0].value.trim();
      if (searchTerm) {
        params.set("q", searchTerm);
      }
    }

    const sortSelect = document.getElementById("SortBy");
    if (sortSelect && sortSelect.value) {
      params.set("sort_by", sortSelect.value);
    }

    return params.toString();
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (event.target.classList.contains("search-facet__input")) {
      return;
    }

    if (event.target.name === "sort_by" || event.target.id === "SortBy") {
      FacetFiltersForm.handleSortChange(event.target);
      return;
    }

    const form = event.target.closest("form");
    const searchParams = this.createSearchParams(form);
    const currentSortValue = document.getElementById("SortBy")?.value;
    const currentSortLabel = document.getElementById("SelectedSortOption")
      ?.textContent;
    if (currentSortValue && currentSortLabel) {
      FacetFiltersForm.currentSortState = {
        value: currentSortValue,
        label: currentSortLabel,
      };
    }

    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }

  static initializeSortDropdown() {
    const sortDropdown = document.getElementById("sortDropdown");
    const sortBySelect = document.getElementById("SortBy");

    if (!sortDropdown || !sortBySelect) {
      return;
    }

    if (!FacetFiltersForm.currentSortState.value && sortBySelect.value) {
      const sortLabel =
        document.getElementById("SelectedSortOption")?.textContent || "";
      FacetFiltersForm.currentSortState = {
        value: sortBySelect.value,
        label: sortLabel,
      };
    }

    const newSortDropdown = sortDropdown.cloneNode(true);
    sortDropdown.parentNode.replaceChild(newSortDropdown, sortDropdown);

    function toggleSortDropdown(event) {
      const optionsContainer = event.currentTarget.querySelector(
        ".custom-select__options"
      );
      if (!optionsContainer) return;

      const isHidden =
        optionsContainer.style.display === "none" ||
        optionsContainer.style.display === "";
      optionsContainer.style.display = isHidden ? "block" : "none";

      if (isHidden) {
        document.addEventListener("click", closeSortDropdown);
      }

      event.stopPropagation();
    }

    function closeSortDropdown(event) {
      if (!event.target.closest(".custom-select")) {
        document
          .querySelectorAll(".custom-select__options")
          .forEach((dropdown) => {
            dropdown.style.display = "none";
          });
        document.removeEventListener("click", closeSortDropdown);
      }
    }

    function selectSortOption(value, name) {
      FacetFiltersForm.currentSortState = { value, label: name };

      const selectedOption = document.getElementById("SelectedSortOption");
      if (selectedOption) {
        selectedOption.textContent = name;
      }

      const select = document.getElementById("SortBy");
      if (select) {
        select.value = value;

        document
          .querySelectorAll(".custom-select__option")
          .forEach((option) => {
            const checkmark = option.querySelector(".custom-select__checkmark");
            if (option.dataset.value === value) {
              checkmark?.classList.add("custom-select__checkmark--visible");
              checkmark?.classList.remove("custom-select__checkmark--hidden");
            } else {
              checkmark?.classList.add("custom-select__checkmark--hidden");
              checkmark?.classList.remove("custom-select__checkmark--visible");
            }
          });

        FacetFiltersForm.handleSortChange(select);
      }

      document
        .querySelectorAll(".custom-select__options")
        .forEach((dropdown) => {
          dropdown.style.display = "none";
        });
    }

    newSortDropdown.addEventListener("click", toggleSortDropdown);

    window.selectSortOption = selectSortOption;

    const newSortBySelect = document.getElementById("SortBy");
    if (newSortBySelect) {
      const clonedSelect = newSortBySelect.cloneNode(true);
      newSortBySelect.parentNode.replaceChild(clonedSelect, newSortBySelect);

      clonedSelect.addEventListener("change", function (event) {
        event.preventDefault();
        FacetFiltersForm.handleSortChange(this);
      });
    }
  }

  static handleSortChange(selectElement) {
    const currentParams = new URLSearchParams(window.location.search);

    const filterParams = new URLSearchParams();

    filterParams.set("sort_by", selectElement.value);

    const searchInputs = document.querySelectorAll(".search-facet__input");
    if (searchInputs.length > 0) {
      const searchTerm = searchInputs[0].value.trim();
      if (searchTerm) {
        filterParams.set("q", searchTerm);
      }
    }

    const filterForms = document.querySelectorAll(
      "#FacetFiltersForm, #FacetFiltersFormMobile"
    );

    filterForms.forEach((form) => {
      if (form) {
        const filterCheckboxes = form.querySelectorAll(
          'input[type="checkbox"]'
        );
        const checkboxGroups = {};

        filterCheckboxes.forEach((checkbox) => {
          if (!checkboxGroups[checkbox.name]) {
            checkboxGroups[checkbox.name] = [];
          }
          checkboxGroups[checkbox.name].push(checkbox);
        });

        Object.keys(checkboxGroups).forEach((name) => {
          const checkboxes = checkboxGroups[name];
          checkboxes.forEach((checkbox) => {
            if (
              checkbox.checked &&
              checkbox.value &&
              checkbox.value.trim() !== ""
            ) {
              filterParams.append(checkbox.name, checkbox.value);
            }
          });
        });

        const formData = new FormData(form);
        for (const [key, value] of formData.entries()) {
          const inputElement = form.querySelector(`input[name="${key}"]`);
          if (
            key === "sort_by" ||
            (inputElement && inputElement.type === "checkbox") ||
            !value ||
            value.trim() === ""
          ) {
            continue;
          }

          if (!filterParams.has(key)) {
            filterParams.set(key, value);
          }
        }
      }
    });

    const searchParams = filterParams.toString();
    FacetFiltersForm.renderPage(searchParams, null, true);
  }

  static restoreSortState(sortValue, sortLabel) {
    const sortSelect = document.getElementById("SortBy");
    const sortLabelElement = document.getElementById("SelectedSortOption");

    if (sortSelect && sortLabelElement) {
      sortSelect.value = sortValue;
      sortLabelElement.textContent = sortLabel;

      document.querySelectorAll(".custom-select__option").forEach((option) => {
        const checkmark = option.querySelector(".custom-select__checkmark");
        if (option.dataset.value === sortValue) {
          checkmark?.classList.add("custom-select__checkmark--visible");
          checkmark?.classList.remove("custom-select__checkmark--hidden");
        } else {
          checkmark?.classList.add("custom-select__checkmark--hidden");
          checkmark?.classList.remove("custom-select__checkmark--visible");
        }
      });
    }
  }

  static initializeSortStateFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortValue = urlParams.get("sort_by");

    if (sortValue) {
      const sortLabels = {
        manual: "Recommended",
        "created-descending": "New Arrival",
        "best-selling": "Best selling",
        "price-ascending": "Price: (low to high)",
        "price-descending": "Price: (high to low)",
      };

      const sortLabel = sortLabels[sortValue] || "Recommended";

      FacetFiltersForm.currentSortState = {
        value: sortValue,
        label: sortLabel,
      };

      setTimeout(() => {
        FacetFiltersForm.restoreSortState(sortValue, sortLabel);
      }, 0);
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.currentSortState = { value: null, label: null };
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

document.addEventListener("DOMContentLoaded", function () {
  FacetFiltersForm.initializeSortDropdown();
  FacetFiltersForm.initializeSortStateFromURL();
});

window.testFilters = FacetFiltersForm.testFilterFunctionality;

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
      element.addEventListener("keydown", this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("data-min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min"));
    const max = Number(input.getAttribute("data-max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

class MobileFacetFiltersForm extends FacetFiltersForm {
  constructor() {
    super();

    this.searchInput = this.querySelector(
      ".custom-search-results #Search-In-Template"
    );
    if (this.searchInput) {
      this.searchInput.addEventListener(
        "input",
        this.handleSearchInput.bind(this)
      );
    }
  }
}

customElements.define("mobile-facet-filters-form", MobileFacetFiltersForm);
